import React from "react";
import TSTable from "../../common/TSTable";
import { Tooltip, DatePicker, Tag, theme } from "antd";
import { URL_LAB, URL_TRUCK } from "../../constants/urls";
import * as _ from "lodash";
import {
  dateToHumanString,
  formatComma,
  getLabResultColor,
  timeToString,
  toFixed,
} from "../../frameworks/Util";
import {
  EditOutlined,
} from '@ant-design/icons';
import ErrorMessages from "../../common/ErrorMessages";
import ReceivingWeightLogModal from "../../components/receiving-latex/ReceivingWeightLogModal";
import { faFlask } from "@fortawesome/free-solid-svg-icons";
import dayjs from 'dayjs';
import { PATH } from "../../routes/CustomRoutes";
import { GET } from "../../frameworks/HttpClient";
import ColorButton from "../../common/ColorButton";
import { LAB_COLOR } from "../../constants/color";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LabResultsModal from "./LabResultsModal";
import { LAB_ORDER_TYPE, LICENSE_PLATE_TYPE } from "../../constants/string";
import SummaryWeightLatex from "../common/SummaryWeightLatex";

const LabTruckHistoryView = React.forwardRef((props, ref) => {
  const [errorMessage, setErrorMessage] = React.useState(null);
  const [targetOutWeightLog, setTargetOutWeightLog] = React.useState(null);
  const [targetInWeightLog, setTargetInWeightLog] = React.useState(null);
  const [target, setTarget] = React.useState(null);
  // const [rangeDate , setRangeDate] = React.useState({date_after : dayjs().format('YYYY-MM-DD'), date_before : dayjs().format('YYYY-MM-DD')});
  const [rangeDate, setRangeDate] = React.useState({date_after : '', date_before : ''});
  const [tableKey, setTableKey] = React.useState(0)
  const tableRef = React.useRef(null);

  const refreshData = async (params = {}) => {
    if (tableRef.current) await tableRef.current.fetch(params);
  };

  const {
    token: { colorWarning },
  } = theme.useToken();

  // const fetchLabTarget = async(id) => {
  //   try {
  //     if(id){
  //       const response = await GET(`${URL_LAB.LAB_ORDER}${id}/`)
  //       setTarget(_.get(response, 'data', null))
        
  //     }  
  //   } catch (error) {
  //     setErrorMessage(error.errorMessage)
  //   }
  // }

  const columns = [
    {
      title: 'Action',
      dataIndex: '',
      width : 60,
      key: 'action',
      render: (value, original) => {
        return (
          <div 
            style={{textAlign:'center'}}
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            <Tooltip triger='hover' title={"ส่งผลแล็บ"}>
              <ColorButton 
                type='primary'
                override={original.is_lab_complete ? colorWarning : LAB_COLOR}
                icon={original.is_lab_complete ? <EditOutlined/> : <FontAwesomeIcon icon={faFlask}/>}
                // onClick={()=> fetchLabTarget(original.lab_order)} 
                onClick={()=> setTarget({lot_no : original.lab_order_code , id : _.get(original, 'lab_order', ''), code : _.get(original, 'lab_order_code', ''), type : LAB_ORDER_TYPE.TRUCK})}
              />
            </Tooltip>
          </div>
      )}
    },
    {
      title: "เลขที่ Order",
      dataIndex: "lab_order_code",
      key: "lab_order_code",
      render: (value) => 
      <center>
        {value}
      </center>
    },
    {
      title: "วันที่",
      dataIndex: "created",
      key: "created",
      render: (value) => {
        return (
          <center>
            <div>{value ? dateToHumanString(value) : "-"}</div>
          </center>
        )
      }
    },
    {
      title: "ทะเบียนรถ",
      dataIndex: "vehicle_license_plate",
      key: "vehicle_license_plate",
      searcher: true,
      render : (value, original) => 
      <center>
        <div>
          <Tooltip triger='hover' title={"ประวัติรถเข้าโรงงาน"}>
            <a onClick={()=> window.open(`${window.origin}${PATH.POND_TRUCK_HISTORY}/${original.id}`)}>
              {value}
            </a>
          </Tooltip>
        </div>
        <div>
        {_.get(original, 'substitute_license_plate', false) ?
          <Tooltip triger='hover' title={"ประวัติทะเบียนแทน"}>
            <a onClick={()=> window.open(`${window.origin}${PATH.POND_TRUCK_HISTORY}/${original.id}/${LICENSE_PLATE_TYPE.SUBTITUTE}`)}>
              {`(${_.get(original, 'substitute_license_plate', '')})`}
            </a>
          </Tooltip> : ''}
        </div>
      </center>
    },
    {
      title: "ลำดับ",
      dataIndex: "index",
      key: "index",
      render: (value) => 
      <center>
        {value}
      </center>
    },
    {
      title: "เที่ยวที่",
      dataIndex: "round_trip",
      key: "round_trip",
      render: (value) => 
      <center>
        {value}
      </center>
    },
    {
      title: "รหัสผู้ขาย",
      dataIndex: "supplier_code",
      key: "supplier_code",
      searcher: true,
    },
    {
      title: "น้ำหนักเข้า",
      dataIndex: "in_weight",
      key: "in_weight",
      render: (value, original) => (
        <>
          <Tooltip triger='hover' title={"ประวัติน้ำหนักเข้า"}>
            <a onClick={() => setTargetInWeightLog({ id: original.id })}>
              {formatComma(toFixed(value, 0))}
            </a>
          </Tooltip>
        </>
      ),
    },
    {
      title: "น้ำหนักออก",
      dataIndex: "out_weight",
      key: "in_weight",
      render: (value, original) => (
        <>
          <Tooltip triger='hover' title={"ประวัติน้ำหนักออก"}>
            <a onClick={() => setTargetOutWeightLog({ id: original.id })}>
              {formatComma(toFixed(value, 0))}
            </a>
          </Tooltip>
        </>
      ),
    },
    {
      title: 'น้ำหนักสุทธิ',
      dataIndex: 'net_weight',
      key: 'net_weight',
      render: (value) => formatComma(toFixed(value, 0))
    },
    {
      title: "Lot น้ำยางสด",
      dataIndex: "pond_input",
      key: "pond_input",
      render: (value, original) =>
        original.pond_input ? (
          <>
            <div>ล็อต : {_.get(original, "lot_no_input", "-")}</div>
            <div>บ่อ : {_.get(original, "pond_input", "-")}</div>
            <div>กระบะ : {_.get(original, "tray_input", "-")}</div>
          </>
        ) : (
          "-"
        ),
    },
    {
      title: "ผลแล็บ",
      dataIndex: "",
      key: "lab_results",
      render: (value, original) => {
        return _.get(original, "lab_results", "-").map((item) => {
          return (
            <div style={{ color: getLabResultColor(_.get(item, 'status', null)) }}>
              <Tooltip title={item.note}>{item.chemical} : {toFixed(item.amount, 3)}</Tooltip>
            </div>
          );
        });
      },
    },
    // {
    //   title: 'ราคา',
    //   dataIndex: 'lab_results',
    //   key: 'lab_results',
    // },

  ];

  const ResetFilter = () => {
    setTableKey(tableKey => tableKey + 1)
  }

  React.useEffect(() => {
    ResetFilter();
  },[rangeDate])

  React.useEffect(() => {
    const interval = setInterval(() => {
      refreshData();
    }, 300000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ marginTop : 16 }}>
      <ErrorMessages message={errorMessage} />
      วันที่ : 
      <DatePicker.RangePicker
        style={{ marginLeft : 10, marginRight : 20, marginBottom : 10 }}
        onCalendarChange={(dates, dateStrings) => setRangeDate({date_after : dateStrings[0], date_before : dateStrings[1]})}
        // defaultValue={[dayjs(), dayjs()]}
      />
      <TSTable
        key={tableKey}
        ref={tableRef}
        columns={columns}
        size={"small"}
        url={URL_TRUCK.TRUCK_TRANSACTION}
        params={{...rangeDate}}
        rowClassName={(record) => {
          if (!record.is_lab_complete) {
            return "table-row-red";
          }
        }}
      />

      <LabResultsModal
        open={target ? true : false}
        onClose={() => {
          setTarget(null)
        }}
        target={target}
        onUpdate={() => {
          setTarget(null)
          refreshData();
        }}
      />

      <ReceivingWeightLogModal
        open={targetInWeightLog ? true : false}
        target={targetInWeightLog}
        onClose={() => setTargetInWeightLog(null)}
        direction={"in"}
      />

      <ReceivingWeightLogModal
        open={targetOutWeightLog ? true : false}
        target={targetOutWeightLog}
        onClose={() => setTargetOutWeightLog(null)}
        direction={"out"}
      />
    </div>
  );
});

export default LabTruckHistoryView;
